/** Identity provider for the app tree; see ./useAuth.ts for the seam. */
import type { ReactNode } from 'react';
import { LogtoProvider } from '@logto/react';

import { logtoConfig } from '../lib/logto';
import { AUTH_MODE } from '../lib/runtimeFlags';

export function AuthProvider({ children }: { children: ReactNode }) {
  if (AUTH_MODE === 'databricks') {
    return <>{children}</>;
  }
  return <LogtoProvider config={logtoConfig}>{children}</LogtoProvider>;
}
